// extracted by mini-css-extract-plugin
export default {"main":"login_main__rFaiw","wrapper":"login_wrapper__fL17d","logo":"login_logo__S2bIa","head":"login_head__vPBEe","title":"login_title__9FnZX"};